// extracted by mini-css-extract-plugin
export default {"socialLinkedIn":"LinkedIn_socialLinkedIn__+jqjE"};